import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionsDialog from 'spw-components/dialogs/actions-dialog';
import { deleteScenario } from 'spw-redux/modules/calculators/actions';
import { selectCurrentScenario } from 'spw-redux/modules/calculators/selectors';
import { useHistory } from 'react-router';
import { currentProject as selectCurrentProject } from 'spw-redux/modules/projects/selectors';
import { Scenario } from 'spw-redux/modules/calculators/types';
import { PlainProgramScenario } from '../../models/Scenario';
import {
  getScenarioListLocation,
  isTotalProgram,
} from './building-hs-sc-scenario/utils';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const useStyles = makeStyles({
  deleteScenarioDialog: {
    '&&': {
      width: '420px',
      height: '200px',
    },
  },
  deleteTpsScenarioDialog: {
    '&&': {
      width: '420px',
      height: '235px',
    },
  },
});

const DeleteScenarioDialog = ({ isOpen, onClose }: Props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const project = useSelector(selectCurrentProject);
  const currentScenario = useSelector(selectCurrentScenario);

  const deleteScenarioDialogProps = isTotalProgram(currentScenario)
    ? {
        title: 'Delete Total Program Scenario',
        description:
          'All summary data in the rolled up scenario will be deleted. Linked scenarios will not be deleted.',
        containerClassName: classes.deleteTpsScenarioDialog,
      }
    : {
        title: 'Delete Scenario',
        description: 'All data associated with the scenario will be deleted.',
        containerClassName: classes.deleteScenarioDialog,
      };

  const handleDeleteScenario = () => {
    onClose();
    dispatch(
      deleteScenario((scenario: Scenario | PlainProgramScenario) => {
        history.replace(getScenarioListLocation(project, scenario));
      })
    );
  };

  return (
    <ActionsDialog
      {...deleteScenarioDialogProps}
      isOpen={isOpen}
      actions={[
        {
          variant: 'delete',
          text: 'DELETE',
          onClick: handleDeleteScenario,
        },
        {
          variant: 'cancel',
          text: 'CANCEL',
          onClick: onClose,
        },
      ]}
    />
  );
};

export default DeleteScenarioDialog;
